import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .world-card {
    background-position: center;
    background-size: cover;
    position: relative;
    height: 146px;
    border-radius: 8px;
    overflow: hidden;
    background-repeat: no-repeat;
    border: 1px solid var(--sds-color-border-default-default);
    transition: transform 0.2s ease;
  }

  .world-card:hover {
    transform: translateY(-2px);
  }

  .gradient-overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(187deg, rgb(17 17 17 / 0.8) 3.03%, rgb(17 17 17 / 0) 30.16%),
      linear-gradient(202deg, rgb(17 17 17 / 0) 25.48%, rgb(17 17 17 / 0.8) 74.88%);
  }

  .content {
    position: absolute;
    bottom: 13px;
    left: 14px;
    right: 14px;
    z-index: 1;
  }

  .world-title {
    font-family: var(--sds-typography-family-body);
    font-weight: 500;
    font-size: 14px;
    line-height: 1.4;
    margin: 0 0 2px 0;
    color: rgb(255 255 255 / 0.7);
  }

  .post-count {
    font-family: var(--sds-typography-family-body);
    font-weight: 400;
    font-size: 12px;
    line-height: 1.5;
    margin: 0;
    color: rgb(255 255 255 / 0.7);
  }

  /* Dropdown */
  .menu {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;

    .menu-dots {
      color: var(--sds-color-white-1000);

      &:hover {
        color: var(--sds-color-icon-default-default);
      }
    }
  }

  /* Status-based styling */
  .world-card[data-status="draft"] {
    opacity: 0.8;
  }

  .world-card[data-status="live"] {
    opacity: 1;
  }
`;
